<div class="mb-3">
  <label [htmlFor]="inputId" class="form-label">
    {{ label() }}
    @if (isRequired && showRequiredIndicator()) {
      <sup class="text-danger">*</sup>
    }
  </label>

  @if (inputType() === 'phoneNumber' || inputType() === 'tel') {
    <p-inputMask
      [id]="inputId"
      styleClass="w-100 form-control"
      mask="(999) 999-9999"
      placeholder="(999) 999-9999"
      [ngModel]="value"
      [disabled]="finalDisabledState"
      [readonly]="finalReadonlyState"
      [autoClear]="false"
      [attr.aria-describedby]="ariaDescribedBy()"
      [ngClass]="{
        'is-invalid': shouldShowError,
        'ng-invalid': shouldShowError,
        'ng-dirty': shouldShowError,
      }"
      (ngModelChange)="onMaskedValueChange($event)"
      (onBlur)="onBlur()"
      (onFocus)="onFocus()" />
  } @else {
    <input
      pInputText
      [id]="inputId"
      [type]="inputType()"
      [placeholder]="placeholder()"
      [value]="value"
      [disabled]="finalDisabledState"
      [readonly]="finalReadonlyState"
      [attr.maxlength]="maxLength()"
      [attr.minlength]="minLength()"
      [autocomplete]="autocomplete()"
      [attr.aria-describedby]="ariaDescribedBy()"
      [ngClass]="{
        'form-control': true,
        'is-invalid': shouldShowError,
        'ng-invalid': shouldShowError,
        'ng-dirty': shouldShowError,
      }"
      (input)="onValueChange($event)"
      (blur)="onBlur()"
      (focus)="onFocus()" />
  }

  @if (hint() && !shouldShowError) {
    <div class="hint">
      {{ hint() }}
    </div>
  }

  @if (shouldShowError) {
    <div class="invalid-feedback d-block">
      {{ errorMessage }}
    </div>
  }
</div>
